/**
 * cardTitle -> string = Título do card
 * cardAdress -> string = Conteúdo com endereço do card
 * cardPhone -> string = Contéudo com telefone do card
 * iconPhone -> string = Imagem com icone para o cardPhone
 * cardOperation -> string = Contéudo com horário de operação
 * iconOperation -> string = Imagem com icone para o cardOperation
 */

import getImage from "../../useFull/getImage";
import './CardStore.css'


const CardStore = props => {

    const { cardTitle, cardAdress, cardPhone, iconPhone, iconOperation, cardOperation } = props

    const imgPhone = getImage('card-store', iconPhone);
    const imgOperation = getImage('card-store', iconOperation);

    return (
        <div className='container-card-store'>
            <div className='container-card-store-title'>
                <span className='text-title-secondary'>{cardTitle}</span>
            </div>
            <div className="container-card-store-adress">
                <span>{cardAdress}</span>
            </div>
            <div className="container-card-store-phone-operation">
                <div className="control-phone">
                    <div className='icon-card-store' style={{
                        backgroundImage: `url(${imgPhone})`
                    }}
                    />
                    <span>{cardPhone}</span>
                </div>

                <div className="control-operation">
                    <div className="container-card-store-phone-operation">
                        <div className='icon-card-store' style={{
                            backgroundImage: `url(${imgOperation})`
                        }}
                        />
                    </div>
                    <span dangerouslySetInnerHTML={{ __html: cardOperation }}/>
                </div>
            </div>
        </div>
    )

}

export default CardStore;